export default [
  {
    key: 'timeShift',
    label: 'label.timeShift',
    // rules: 'required',
    fakeRequired: true,
    type: 'async-single-selection',
    repository: 'timeShift',
    selectionKey: 'id',
    selectionLabel: 'translations',
    isObject: true,
    cols: 12,
    showAddNew: true,
  },
  {
    key: 'repeatType',
    label: 'label.repeatType',
    rules: 'required',
    cols: 12,
    type: 'single-selection',
    rows: '5',
    options: [
      {
        value: 'none',
        name: 'label.none',
      },
      {
        value: 'daily',
        name: 'label.everyDay',
      },
      {
        value: 'weekly',
        name: 'label.everyWeek',
      },
      {
        value: 'monthly',
        name: 'label.everyMonth',
      },
      {
        value: 'yearly',
        name: 'label.everyYear',
      },
      {
        value: 'custom',
        name: 'label.custom',
      },
    ],
  },
]
